import { Selector, State as S, State } from 'model/State';
import Progress from 'redux-progress';
import { AccountDetail } from '../models';

export const selectDetails: (state: State, accountId: string) => AccountDetail = (
  state: State,
  accountId: string,
) => state.mac.accounts.details?.[accountId]?.ifSuccess((r) => r);

export const selectDetailsGeneralObject: Selector<object> = (state: State) =>
  state.mac.accounts.details;

export const selectCustomerAccountOverviewsByPartnerSearchDTO: Selector<
  Progress<boolean | string>
> = (state) => state.mac.accounts.getCustomerAccountOverviewsByPartnerSearchDTO.ifSuccess((r) => r);

export const selectIsUpgradableAccount: Selector<Progress<boolean>> = (state) =>
  state.mac.accounts.isUpgradableAccount.ifSuccess((r) => r);

export const selectIsRenewableAccount: Selector<Progress<boolean>> = (state) =>
  state.mac.accounts.isRenewableAccount.ifSuccess((r) => r);

export const selectIsEvaluationAllowed: Selector<boolean | null> = (state: S) =>
  state.mac.accounts.isEvaluationAllowed?.ifSuccess((r) => r);

export const selectAsyncCustomerAccountOverviewsByPartnerSearchDTO: Selector<string | null> = (
  state,
) =>
  state.mac.accounts.getAsyncCustomerAccountOverviewsByPartnerSearchDTO.ifSuccess((r) => r || null);

export const selectNewContact: (state: S) => {} = (state: S) =>
  state.mac.accounts.newContact?.ifSuccess((r) => r);
